import {
  Divider,
  Flex,
  Icon,
  Input,
  InputGroup,
  InputLeftElement,
  Stack,
} from '@chakra-ui/react';
import {
  FiBarChart2,
  FiBookmark,
  FiCheckSquare,
  FiHelpCircle,
  FiHome,
  FiSearch,
  FiSettings,
  FiUsers,
} from 'react-icons/fi';
import { Logo } from './Logo';
import { NavButton } from './NavButton';
import { UserProfile } from './UserProfile';

export const SideBar = () => (
  <Flex as="section" minH="100vh" bg="bg-canvas">
    <Flex
      flex="1"
      bg="bg-surface"
      overflowY="auto"
      boxShadow="sm"
      maxW={{ base: 'full', sm: 'xs' }}
      py={{ base: '6', sm: '8' }}
      px={{ base: '4', sm: '6' }}
    >
      <Stack justify="space-between" spacing="1">
        <Stack spacing={{ base: '5', sm: '6' }} shouldWrapChildren>
          <Logo />
          <InputGroup>
            <InputLeftElement pointerEvents="none">
              {/* @ts-ignore */}
              <Icon as={FiSearch} color="muted" boxSize="5" />
            </InputLeftElement>
            <Input placeholder="Search" />
          </InputGroup>
          <Stack spacing="1">
            <NavButton label="Home" icon={FiHome} to={''} />
            <NavButton
              label="Dashboard"
              icon={FiBarChart2}
              aria-current="page"
              to={''}
            />
            <NavButton label="Tasks" icon={FiCheckSquare} to={''} />
            <NavButton label="Bookmarks" icon={FiBookmark} to={''} />
            <NavButton label="Users" icon={FiUsers} to={''} />
          </Stack>
        </Stack>
        <Stack spacing={{ base: '5', sm: '6' }}>
          <Stack spacing="1">
            <NavButton label="Help" icon={FiHelpCircle} to={''} />
            <NavButton label="Settings" icon={FiSettings} to={''} />
          </Stack>
          <Divider />
          <UserProfile
          // image="https://tinyurl.com/yhkm2ek8"
          // email="chris@chakra-ui.com"
          />
        </Stack>
      </Stack>
    </Flex>
  </Flex>
);

// export const SideBar = () => {
//   const iconBoxSize = '10';

//   return (
//     <Flex
//       flex="1"
//       bg="bg-accent"
//       color="on-accent"
//       overflowY="auto"
//       maxW={{ base: 'full', sm: 'xs' }}
//       py={{ base: '6', sm: '8' }}
//       px={{ base: '4', sm: '4' }}
//       boxShadow={useColorModeValue('xs', 'sm-dark')}
//     >
//       <Stack justify="space-between" spacing="1" width="full" m="62px 0 0 0">
//         <Stack spacing="8" shouldWrapChildren>
//           {/* <Logo /> */}

//           <Stack>
//             <Stack
//               spacing="4"
//               flex="1"
//               divider={<Divider orientation="horizontal" />}
//             >
//               <NavButton to="dashboard" label="Dashboard" icon={FiActivity} />
//               <NavButton
//                 to="programs/search"
//                 label="Programs"
//                 icon={FiDollarSign}
//               />
//               <NavButton
//                 to="projects/search"
//                 label="Projects"
//                 icon={FiSliders}
//               />
//               <NavButton
//                 to="purchase-orders/search"
//                 label="Purchase Orders"
//                 icon={FiPenTool}
//               />
//               <NavButton
//                 to="work-orders/search"
//                 label="Work Orders"
//                 icon={FiPenTool}
//               />
//               <NavButton
//                 to="invoices/search"
//                 label="Invoices"
//                 icon={FiLayers}
//               />
//             </Stack>
//           </Stack>
//           {/* <Stack>
//                         <Text fontSize="sm" color="on-accent-muted" fontWeight="medium">
//                             Social
//                         </Text>
//                         <Stack spacing="1">
//                             <NavButton label="Twitter" icon={FiTwitter} />
//                             <NavButton label="Instagram" icon={FiInstagram} />
//                             <NavButton label="Linkedin" icon={FiLinkedin} />
//                         </Stack>
//                     </Stack> */}
//         </Stack>
//       </Stack>
//     </Flex>
//   );

// return (
//     <Flex as="section" minH="100vh" bg="bg-canvas">
//     <Flex
//         flex="1"
//         bg="bg-accent"
//         color="on-accent"
//         maxW={{ base: 'full', sm: 'xs' }}
//         py={{ base: '6', sm: '8' }}
//         px={{ base: '4', sm: '6' }}
//     >
//         <Stack justify="space-between" spacing="1">
//             <Stack spacing={{ base: '5', sm: '6' }} shouldWrapChildren>
//                 {/* <Logo /> */}
//                 {/* <InputGroup>
//                     <InputLeftElement pointerEvents="none">
//                         <Icon as={FiSearch} color="on-accent" boxSize="5" />
//                     </InputLeftElement>
//                     <Input placeholder="Search" variant="filled" colorScheme="blue" />
//                 </InputGroup> */}
//                 <Stack spacing="1">
//                     <Link to="dashboard"><Icon as={FiBarChart} boxSize={iconBoxSize} color="on-accent-subtle" padding={1} /></Link>
//                     <Link to="programs"><Icon as={FiActivity} boxSize={iconBoxSize} color="on-accent-subtle" padding={1} /></Link>
//                     <Link to="projects"><Icon as={FiCalendar} boxSize={iconBoxSize} color="on-accent-subtle" padding={1} /></Link>
//                     <Link to="commitments"><Icon as={FiEdit3} boxSize={iconBoxSize} color="on-accent-subtle" padding={1} /></Link>
//                     {/* <Link to="search/invoices"><Icon as={FiDollarSign} boxSize={iconBoxSize} color="on-accent-subtle" padding={1} /></Link> */}
//                     <Link to="invoices/search"><Icon as={FiDollarSign} boxSize={iconBoxSize} color="on-accent-subtle" padding={1} /></Link>
//                     {/* <NavButton label="Bookmarks" icon={FiBookmark} />
//                     <NavButton label="Users" icon={FiUsers} /> */}
//                 </Stack>
//             </Stack>
//             <Stack spacing={{ base: '5', sm: '6' }} maxW="24px">
//                 <Stack spacing="1">
//                     <Link to="help"><Icon as={FiHelpCircle} boxSize={iconBoxSize} color="on-accent-subtitle" padding={1} /></Link>
//                     <Link to="settings"><Icon as={FiSettings} boxSize={iconBoxSize} color="on-accent-subtitle" padding={1} /></Link>
//                 </Stack>
//                 {/* <Divider />
//                 <UserProfile
//                     name="Christoph Winston"
//                     image="https://tinyurl.com/yhkm2ek8"
//                     email="chris@chakra-ui.com"
//                 /> */}
//             </Stack>
//         </Stack>
//     </Flex>
// </Flex>
// );
// };
